export default "__VITE_ASSET__CehDqCHw__"